/**
 * Route Constants
 * File to hold constants related to routing.
 */

export const SHOP = {
  STORE_TYPE: 'shop',
  BASE_URI: '/shop',
  BASE_PRODUCT_URI: '/shop/product',
  BASE_CATEGORY_URI: '/shop/category',
  SEARCH_URI: '/shop/search',
  CHECKOUT_URI: '/shop/checkout',
  ORDER_COMPLETE_URI: '/shop/complete',
  PAGE_TITLE: 'Shop',
  MAX_QUANTITY_PURCHASE: 10,
  SEARCH_PLACEHOLDER_TEXT: 'Search the Glowforge Shop',
  SHOW_CART: true,
  SHOW_SEARCH: true,
  ENABLED: false, // These will be flipFlop checks in the future
};

export const CATALOG = {
  STORE_TYPE: 'catalog',
  BASE_URI: '/catalog',
  BASE_PRODUCT_URI: '/catalog/product',
  BASE_CATEGORY_URI: '/catalog/category',
  SEARCH_URI: '/catalog/search',
  PAGE_TITLE: 'Design Catalog',
  SEARCH_PLACEHOLDER_TEXT: 'Search for Designs',
  SHOW_CART: false,
  SHOW_SEARCH: true,
  ENABLED: false,
};

export const GLOWFORGE_STORE = {
  PAGE_TITLE: 'Order - Glowforge - the 3D laser printer',
  BASE_URI: '/order',
  HIDE_NAV_LINKS: true,
  USE_MARKETING_NAV: true,
};

export const GLOWFORGE_CONFIRMATION = {
  BASE_URI: '/confirmation',
  SHOW_GLOBAL_FOOTER: true,
  USE_MARKETING_NAV: true,
  HIDE_NAV_LINKS: true,
};

export const SUPPORT = {
  BASE_URI: '/support',
  SHOW_CART: false,
  SHOW_SEARCH: false,
  SUPPORT_ENTRY_TYPES: [
    'questionAndAnswer',
    'supportEntryInstructions',
    'supportEntryTextAndMedia',
    'supportEntryTipOrAlert',
  ],
};

export const SETTINGS = {
  PAGE_TITLE: 'User Settings',
  BASE_URI: '/settings',
};

export const CREATE_ACCOUNT = {
  PAGE_TITLE: 'Create Account',
  BASE_URI: '/create-account',
  USE_MARKETING_NAV: true,
};

export const WARRANTY = {
  PAGE_TITLE: 'Warranty',
  BASE_URI: '/warranty',
  HIDE_NAV_LINKS: true,
};

export const PATENTS = {
  PAGE_TITLE: 'Patents',
  BASE_URI: '/patents',
  HIDE_NAV_LINKS: true,
};

export const TERMS = {
  PAGE_TITLE: 'Terms',
  BASE_URI: '/terms',
  USE_MARKETING_NAV: true,
};

export const REFERRAL_PAYMENT = {
  PAGE_TITLE: 'Referral Payment',
  BASE_URI: '/referral-payment',
};

export const REFERRALS = {
  PAGE_TITLE: 'Referrals',
  BASE_URI: '/referrals',
};

export const SETTINGS_ACCEPT_INVITE = {
  PAGE_TITLE: 'User Create',
  BASE_URI: '/settings/invite/accept',
  HIDE_NAV_LINKS: true,
  HIDE_USER_SECTION: true,
};

export const MARKETING = {
  BASE_URI: '/m/',
  USE_MARKETING_NAV: true,
  INCLUDE_BUY_BUTTON: true,
};

export const SETUP = {
  PAGE_TITLE: 'Glowforge',
  BASE_URI: '/setup',
  HIDE_NAV_LINKS: true,
  HIDE_USER_SECTION: true,
};

export const JOBS = {
  PAGE_TITLE: 'Jobs',
  BASE_URI: '/jobs',
  USE_MARKETING_NAV: true,
  INCLUDE_BUY_BUTTON: true,
  SHOW_GLOBAL_FOOTER: true,
};

export const REVIEWS = {
  PAGE_TITLE: 'Glowforge Reviews',
  BASE_URI: '/reviews',
  USE_MARKETING_NAV: true,
  INCLUDE_BUY_BUTTON: true,
  SHOW_GLOBAL_FOOTER: true,
};

export const CUSTOMER_GALLERY = {
  PAGE_TITLE: 'Customer Gallery',
  BASE_URI: '/discover',
  USE_MARKETING_NAV: true,
  INCLUDE_BUY_BUTTON: true,
  SHOW_GLOBAL_FOOTER: true,
};

export const GLOWFORGE_PRODUCTS_PAGE = {
  PAGE_TITLE: 'Glowforge Products',
  BASE_URI: '/our-products',
  USE_MARKETING_NAV: true,
  INCLUDE_BUY_BUTTON: true,
  SHOW_GLOBAL_FOOTER: true,
};

export const GLOWFORGE_LANDING_PAGE = {
  PAGE_TITLE: 'Glowforge - the 3D laser printer',
  BASE_URI: '/',
  USE_MARKETING_NAV: true,
  INCLUDE_BUY_BUTTON: true,
  SHOW_GLOBAL_FOOTER: true,
};

export const GLOWFORGE_LANDING_PAGE_HOME = {
  ...GLOWFORGE_LANDING_PAGE,
  BASE_URI: '/home',
  INCLUDE_BUY_BUTTON: true,
  CANONICAL_URI: '/',
};

export const GLOWFORGE_LANDING_PAGE_HOME_CDN_TEST = {
  ...GLOWFORGE_LANDING_PAGE,
  BASE_URI: '/home-2',
  INCLUDE_BUY_BUTTON: true,
  CANONICAL_URI: '/',
};

export const PAGE_NOT_FOUND = {
  BASE_URI: '/404',
  USE_MARKETING_NAV: true,
  SHOW_GLOBAL_FOOTER: true,
};

export const LOGIN = {
  PAGE_TITLE: 'Sign In',
  BASE_URI: '/login',
  USE_MARKETING_NAV: true,
  SHOW_GLOBAL_FOOTER: true,
};

export const LOGOUT = {
  PAGE_TITLE: 'Sign Out',
  BASE_URI: '/logout',
};

export const COMMON = {
  PAGE_ERRORS: {
    PAGE_NOT_FOUND: '404',
    NOT_AUTHENTICATED: '401',
  },
};

export const MANUAL = {
  PAGE_TITLE: 'Manual',
  BASE_URI: '/manual',
  USE_MARKETING_NAV: true,
  INCLUDE_BUY_BUTTON: true,
  SHOW_GLOBAL_FOOTER: true,
};



// WEBPACK FOOTER //
// ./app/route-constants.js